const project = {
  slug: "smartvaathi-elearning",
  title: "SmartVaathi - E-Learning Platform",
  oneLiner: "Modular courses, progress tracking, instructor dashboards, certificates.",
  role: ["Front-end Developer"],
  category: ["Web Development", "App Development"],
  clientOrOrg: "SmartVaathi",
  timeframe: { start: "2024-06", end: "2025-08", status: "Archived" },
  domain: ["EdTech"],
  tech: ["React", "Laravel", "Flutter"],
  links: { live: "https://smartvaathi.com" },
  gallery: [
  {
    src: "/assets/smartvaathi/smartvaathi-1.png",
    alt: "smartvaathi-1"
  },
  {
    src: "/assets/smartvaathi/smartvaathi-2.png",
    alt: "smartvaathi-2"
  },
  {
    src: "/assets/smartvaathi/smartvaathi-3.png",
    alt: "smartvaathi-3"
  },
],
  impact: [
    "Delivered learner progress, assignments, and certificate downloads.",
    "Improved UX consistency and performance across devices."
  ],
  responsibilities: [
    "React UI implementation and state management",
    "Collaborated on API contracts and component library"
  ],
  features: [
    "Course modules & assessments",
    "Progress dashboards (student/instructor)",
    "Certificate issuing"
  ],
  architecture: [
    "React SPA + Laravel APIs",
    "Flutter app for mobile learners",
    "MySQL + object storage for assets"
  ],
  seo: {
    title: "SmartVaathi E-Learning - Front-end Case Study",
    description:
      "Built modular course experiences with progress tracking and certificates using React with a Laravel/Flutter stack."
  },
  cover: "/assets/smartvaathi/smartvaathi-featured.png"
};

export default project;
